import { useAppContext } from '@/context';
import { logout } from '@/utils/auth';
import { deleteJson } from '@/utils/fetchOptions';

// eslint-disable-next-line import/no-cycle
import { useAuthToken, useMutation } from '.';

interface UseTeamMemberRemoveProps {
  onSuccess: TypeAny;
  teamId: string;
  userId: string;
}

export function useTeamMemberRemove({ onSuccess, teamId, userId }: UseTeamMemberRemoveProps) {
  const { setAlert } = useAppContext();
  const token = useAuthToken();

  const {
    mutate: mutation,
    error,
    isLoading
  } = useMutation({
    mutationKey: 'team-member-remove',
    mutationFn: async () =>
      deleteJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/team/${teamId}/member/${userId}/remove`,
        token
      }).then((response: object | ResponseObject) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response) {
          setAlert(response.code);
        }

        return response;
      }),
    onSuccess
  });

  return {
    isLoading,
    mutation,
    error
  };
}
